'use client';

import { useState } from 'react';

interface Client {
  name: string;
  domain: string;
  abbr: string;
  color: string;
  logoImage?: string;
}

const clients: Client[] = [
  // Energy & Oil
  { name: 'Azzawiya Oil Refining Company', domain: 'azzawiyaoil.ly', abbr: 'AORC', color: '#b45309', logoImage: '/assets/images/image-1776979285579.png' },
  { name: 'Waha Oil Company', domain: 'wahaoil.com', abbr: 'WOC', color: '#92400e', logoImage: '/assets/images/image-1776979860061.png' },
  { name: 'Ar-Razi', domain: 'ar-razi.com', abbr: 'ARZ', color: '#d97706', logoImage: '/assets/images/image-1776979949914.png' },
  { name: 'National Oil Corporation', domain: 'noc.ly', abbr: 'NOC', color: '#78350f', logoImage: '/assets/images/image-1776980086954.png' },
  { name: 'Arabian Gulf Oil Company', domain: 'agoco.com.ly', abbr: 'AGOC', color: '#78350f', logoImage: '/assets/images/image-1776980446363.png' },
  { name: 'GRTECH', domain: 'grtech.ly', abbr: 'GRT', color: '#92400e', logoImage: '/assets/images/image-1777031209217.png' },
  // Government & Public Sector
  { name: 'Ministry of Justice', domain: 'moj.gov.sa', abbr: 'MOJ', color: '#1d4ed8', logoImage: '/assets/images/image-1777032083195.png' },
  { name: 'Ministry of Health', domain: 'moh.gov.sa', abbr: 'MOH', color: '#1e40af', logoImage: '/assets/images/image-1776981182833.png' },
  { name: 'Saudi Vision 2030', domain: 'vision2030.gov.sa', abbr: 'V30', color: '#1d4ed8', logoImage: '/assets/images/a-1777187264618.jpeg' },
  { name: 'Saudi Bar Association', domain: 'sba.org.sa', abbr: 'SBA', color: '#1e3a8a', logoImage: '/assets/images/image-1776981304604.png' },
  { name: 'Telecom Regulatory Authority', domain: 'tra.org.bh', abbr: 'TRA', color: '#1d4ed8', logoImage: '/assets/images/image-1777187177425.png' },
  // Banking & Finance
  { name: 'Al Rajhi Bank', domain: 'alrajhibank.com.sa', abbr: 'ARB', color: '#065f46', logoImage: '/assets/images/image-1777054809751.png' },
  { name: 'Kuwait Finance House', domain: 'kfh.com', abbr: 'KFH', color: '#047857', logoImage: '/assets/images/image-1776980730720.png' },
  { name: 'Amen Bank', domain: 'amenbank.com.tn', abbr: 'AMN', color: '#065f46', logoImage: '/assets/images/image-1777186564663.png' },
  { name: 'UIB', domain: 'uib.com.tn', abbr: 'UIB', color: '#064e3b', logoImage: '/assets/images/image-1777186451559.png' },
  { name: 'STB Bank', domain: 'stb.com.tn', abbr: 'STB', color: '#047857', logoImage: '/assets/images/image-1777032479546.png' },
  { name: 'BH Bank', domain: 'bhbank.com.tn', abbr: 'BHB', color: '#065f46', logoImage: '/assets/images/image-1777186925225.png' },
  { name: 'BTL Bank', domain: 'btl.com.tn', abbr: 'BTL', color: '#064e3b', logoImage: '/assets/images/image-1776981073145.png' },
  { name: 'Sotugar', domain: 'sotugar.com.tn', abbr: 'STG', color: '#047857', logoImage: '/assets/images/image-1777186949808.png' },
  { name: 'BTK Bank', domain: 'btk.com.tn', abbr: 'BTK', color: '#065f46', logoImage: '/assets/images/image-1777186756523.png' },
  { name: 'NAIB Bank', domain: 'naib.com.ly', abbr: 'NAIB', color: '#064e3b', logoImage: '/assets/images/image-1776980775704.png' },
  { name: 'Bank Negara Malaysia', domain: 'bnm.gov.my', abbr: 'BNM', color: '#003087', logoImage: '/assets/images/bank_negara_Malaysia-1777031687588.png' },
  { name: 'BNA Bank', domain: 'bna.com.tn', abbr: 'BNA', color: '#047857', logoImage: '/assets/images/image-1777186714014.png' },
  { name: 'Al Baraka', domain: 'albaraka.com', abbr: 'ABK', color: '#065f46', logoImage: '/assets/images/image-1777186689578.png' },
  { name: 'IIiBF', domain: 'iiibf.org', abbr: 'IIiBF', color: '#064e3b', logoImage: '/assets/images/image-1777186517838.png' },
  // Education & Development
  { name: 'Baseerah International School', domain: 'baseerah.edu.my', abbr: 'BIS', color: '#6d28d9', logoImage: '/assets/images/image-1777186339342.png' },
  { name: 'IIUM', domain: 'iium.edu.my', abbr: 'IIUM', color: '#5b21b6', logoImage: '/assets/images/image-1777186823467.png' },
  { name: 'Global Green Growth Institute', domain: 'gggi.org', abbr: 'GGGI', color: '#4c1d95', logoImage: '/assets/images/gggi_logo-1777055550195.jpeg' },
  { name: 'Kiwano', domain: 'kiwano.com', abbr: 'KWN', color: '#5b21b6', logoImage: '/assets/images/image-1777186106044.png' },
];

// Split clients into two rows
const row1 = clients.slice(0, Math.ceil(clients.length / 2));
const row2 = clients.slice(Math.ceil(clients.length / 2));

interface LogoCardProps {
  client: Client;
}

const LogoCard = ({ client }: LogoCardProps) => {
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <div className="flex flex-col items-center justify-center bg-white border border-gray-100 rounded-xl p-4 h-24 w-40 flex-shrink-0 shadow-sm hover:shadow-md hover:border-gray-200 transition-all duration-200 group mx-2">
      {client.logoImage && !imgFailed ? (
        <img
          src={client.logoImage}
          alt={`${client.name} logo`}
          className="max-h-10 max-w-full w-auto object-contain"
          onError={() => setImgFailed(true)}
          loading="lazy"
        />
      ) : !client.logoImage && !imgFailed ? (
        <img
          src={`https://img.logo.dev/${client.domain}?token=pk_TCkDECCfRqKGMdMbBCyGAA&size=80&format=png`}
          alt={`${client.name} logo`}
          className="max-h-10 max-w-full w-auto object-contain"
          onError={() => setImgFailed(true)}
          loading="lazy"
        />
      ) : (
        <div
          className="flex items-center justify-center rounded-lg w-12 h-10 text-white text-xs font-bold tracking-wide"
          style={{ backgroundColor: client.color }}
        >
          {client.abbr}
        </div>
      )}
      <p className="mt-2 text-[10px] text-gray-500 text-center leading-tight line-clamp-2 max-w-full px-1 group-hover:text-gray-700 transition-colors">
        {client.name}
      </p>
    </div>
  );
};

interface MarqueeRowProps {
  items: Client[];
  reverse?: boolean;
  duration?: number;
}

const MarqueeRow = ({ items, reverse = false, duration = 40 }: MarqueeRowProps) => {
  // Duplicate items for seamless infinite loop
  const doubled = [...items, ...items];

  return (
    <div className="overflow-hidden w-full">
      <div
        className="flex"
        style={{
          animation: `marquee${reverse ? 'Reverse' : ''} ${duration}s linear infinite`,
          width: 'max-content',
        }}
      >
        {doubled.map((client, idx) => (
          <LogoCard key={`${client.name}-${idx}`} client={client} />
        ))}
      </div>
    </div>
  );
};

const InstitutionsServed = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 lg:py-28 bg-gray-50 border-t border-gray-100">
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marqueeReverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>

      <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <p className="text-xs sm:text-sm font-semibold tracking-widest uppercase text-[#14b8a6] mb-2 sm:mb-3">
            Our Clients
          </p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 tracking-tight">
            Clients Served by Our Team
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed px-2">
            A diverse portfolio of institutions across energy, government, banking, and education sectors — spanning the MENA region and beyond.
          </p>
        </div>

        {/* Marquee Rows */}
        <div className="space-y-3 sm:space-y-4 relative">
          {/* Fade edges */}
          <div className="absolute inset-y-0 left-0 w-12 sm:w-24 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" />
          <div className="absolute inset-y-0 right-0 w-12 sm:w-24 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" />

          <MarqueeRow items={row1} reverse={false} duration={45} />
          <MarqueeRow items={row2} reverse={true} duration={38} />
        </div>

        {/* Footer Note */}
        <p className="text-center text-xs text-gray-400 mt-8 sm:mt-10 max-w-xl mx-auto leading-relaxed px-4">
          Engagements span strategy development, leadership capacity building, institutional governance, and advisory support across the public, private, and development sectors.
        </p>
      </div>
    </section>
  );
};

export default InstitutionsServed;
